<template>
    <v-container py-1>
        <v-layout wrap>
            <v-flex xs12>

                <h2 class="title font-weight-regular mb-2">Tipo de consulta y {{clientLabel.toLowerCase()}}{{type === 'individual' ? '' : 's'}}</h2>

                <v-divider class="py-2"></v-divider>

                <v-layout wrap>

                    <v-flex xs12>
                        <psychologist-appointment-type-selector @change="type = $event" />
                    </v-flex>

                    <!--Main client-->
                    <v-flex xs12 mt-3>

                        <client-picker
                                v-if="!user"
                                :provider-id="providerId"
                                :label="`RUT del ${clientLabel.toLowerCase()} principal`"
                                :internal="internal"
                                :requiredFields="requiredFields"
                                :requestedFields="requestedFields"
                                @change="user = $event" />

                        <client-card-item
                                @remove="user = null"
                                :label="`${clientLabel} Principal`"
                                v-else
                                :internal="internal"
                                :client="user" />

                    </v-flex>

                    <v-flex xs12 my-0>

                        <template v-if="type === 'two'">

                            <client-picker
                                    v-if="!companions[0]"
                                    :provider-id="providerId"
                                    label="RUT de su pareja"
                                    :requiredFields="requiredFields"
                                    :requestedFields="requestedFields"
                                    :internal="internal"
                                    @change="onFianceeChange" />

                            <client-card-item
                                    @remove="companions.pop()"
                                    label="Pareja"
                                    v-else
                                    :internal="internal"
                                    :client="companions[0]" />

                        </template>

                        <template v-if="type === 'group'">

                            <client-card-item
                                    v-for="(companion, index) in companions"
                                    :key="companion.id"
                                    @remove="companions.splice(index, 1)"
                                    label="Participante"
                                    :internal="internal"
                                    :client="companion" />

                            <client-picker
                                    label="RUT de nuevo participante"
                                    :provider-id="providerId"
                                    :requiredFields="requiredFields"
                                    :requestedFields="requestedFields"
                                    :internal="internal"
                                    @change="onParticipantChange" />

                        </template>

                    </v-flex>


                </v-layout>

            </v-flex>
        </v-layout>
    </v-container>


</template>

<script>

    import {getLabel} from '@/utils/Institution'

    import { mapMutations } from 'vuex'

    import ClientPicker from '../../../../components/appointments/steps/ClientPicker'
    import ClientCardItem from '@/components/appointments/steps/ClientCardItem'
    import PsychologistAppointmentTypeSelector from './PsychologistAppointmentTypeSelector.vue'
    import AppointmentConfigMixin from "@/mixins/AppointmentConfigMixin";

    export default{
        components:{
            PsychologistAppointmentTypeSelector,
            ClientCardItem,
            ClientPicker
        },
        mixins: [AppointmentConfigMixin],
        props:{
            internal: {
                type: Boolean,
                default: false
            },
            requiredFields:{
                type: Array
            },
            requestedFields:{
                type: Array
            },
            providerId: {
              type: Number
            }
        },
        mounted(){
          const vm = this
          vm.setDefaultClients()
        },
        data(){
            return {
                dialog: false,
                type: 'individual',
                user: null,
                companions: []
            }
        },
        methods:{
                ...mapMutations(['showSnackBar']),
            onParticipantChange(user){

                if(!user) return

                var vm = this
                const existing = vm.companions.find(usr => user.id === usr.id)
                if(existing || user.id === vm.user.id){
                    vm.showSnackBar({
                        text: `Este ${vm.clientLabel.toLowerCase()} ya está en el listado`
                    })
                    return
                }

                vm.companions.push(user)

            },
            onFianceeChange(user){

                var vm = this
                if(!user) {
                    vm.companions = []
                    return
                }

                const existing = vm.companions.find(usr => user.id === usr.id)
                if(existing || user.id === vm.user.id){
                    vm.showSnackBar({
                        text: `Este ${vm.clientLabel.toLowerCase()} ya está en el listado`
                    })
                    return
                }

                if(vm.companions.length === 0){
                    vm.companions.push(user)
                }else{
                    vm.companions = [ user ]
                }
            }
        },
        computed:{
            clientLabel(){
              return getLabel('commons.client.singular')
            },
            companionsMap(){

                var vm = this
                if(vm.type === 'individual' || vm.companions.length === 0) return []
                var relation = vm.type === 'two' ? 'fiancee' : 'other'

                const map = vm.companions.map(companion => {
                    return {
                        id: companion.id,
                        relationship: relation
                    }
                })

                if(vm.type === 'two') return [map[0]]

                return map

            },
            config(){
                var vm = this
                return {
                    user_id: vm.user && vm.user.id || null,
                    sub_type: vm.type,
                    companions: vm.companionsMap
                }
            },
            valid(){

                var vm = this
                if(!vm.user) return false

                if(vm.type == 'two' && vm.companions.length !== 1) return false

                if(vm.type == 'group' && vm.companions.length === 0) return false

                return true

            }
        },
        watch:{
            valid(val){
                this.$emit('valid', val)
            },
            config(val){
                this.$emit('change', val)
            }
        }
    }
</script>
